<template>
	<div class="halloweenAuthWrap">
		<div class="elements">
			<div class="moon"><img src="https://cdn.pixabay.com/photo/2012/04/10/17/38/moon-26619_960_720.png" /></div>
			<img src="https://cdn.pixabay.com/photo/2013/09/25/19/47/witchs-house-186463_960_720.png" class="house"/>
			<img src="https://cdn.pixabay.com/photo/2013/07/12/16/38/halloween-151310_960_720.png" class="cat"/>
			<div class="hanger">
				<img src="https://cdn.pixabay.com/photo/2016/03/31/21/05/animal-1296176_960_720.png" class="bat"/>
			</div>
			<div class="hanger witch-hanger">
				<img src="https://cdn.pixabay.com/photo/2016/10/18/18/49/witch-1751025_960_720.png" class="witch"/>
			</div>
			<img src="https://cdn.pixabay.com/photo/2014/04/03/11/08/tree-311863_960_720.png" class="tree"/>
			<div class="pumpkin"></div>
			<div class="pumpkin pumpkin-2"></div>
			<div class="pumpkin pumpkin-3"></div>
			<div class="pumpkin pumpkin-4"></div>
			<div class="pumpkin pumpkin-5"></div>
			<div class="pumpkin pumpkin-6"></div>
			<div class="ground">
				<div class="fog-1"><img src="https://cdn.pixabay.com/photo/2013/07/13/12/12/cloud-159388_960_720.png"/></div>
				<div class="fog-2"><img src="https://cdn.pixabay.com/photo/2013/07/13/12/12/cloud-159388_960_720.png"/></div>
				<div class="ground-01"></div>
				<div class="ground-02"></div>
				<div class="ground-1"></div>
				<div class="ground-2"></div>
				<div class="ground-3"></div>
			</div>
		</div>

		<div class="lighting"></div>
		<div class="roll">
			<div class="content">
				<h1>Halloween</h1>

				<div class="auth-component">
					<div class="logoBlock">
						<svg-sprite width="240" height="58" icon-id="logo"></svg-sprite>
					</div>
					<login></login>
				</div>
			</div>
		</div>

<!--		<div class="audio-container">-->

<!--			<p id="soundTitle">Audio Controls:</p>-->

<!--			<audio controls autoplay loop>-->
<!--				<source src="https://adevelopersprofile.com/CodePen/Audio/TheAbandonedManor190673.mp3" type="audio/ogg">-->
<!--				Your browser does not support the audio element.-->
<!--			</audio>-->

<!--		</div>-->

		<bg-audio
				:sources="[
        { src: 'https://adevelopersprofile.com/CodePen/Audio/TheAbandonedManor190673.mp3', type: 'audio/mpeg' },
        // опційно друге джерело:
        // { src: '/audio/theme.ogg', type: 'audio/ogg' }
      ]"

				:attemptAutoplay="true"
				:loop="true"
				:controls="true"
				@autoplay-blocked="onBlocked"
				:start-volume="0.2"
				:muted-on-start="false"
		/>

	</div>
</template>

<script>
import Login from "@/components/Auth/Login/Login.vue";
import BgAudio from "@/components/Auth/HalloweenAuth/BgAudio.vue";

export default {
	name: "HalloweenAuth",
	components: { BgAudio, Login },
	methods: {
		onBlocked() {
			// тут можете показати тост/повідомлення користувачу
			// this.$toast.info('Натисніть «Увімкнути», щоб запустити звук')
		}
	}
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Irish+Grover&family=Festive&family=Montserrat:wght@800&display=swap');

* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

body {
	background: rgb(35,7,48);
	background: linear-gradient(0deg, rgba(35,7,48,1) 0%, rgba(95,21,111,1) 20%, rgba(225,97,53,1) 100%) fixed;
}
.halloweenAuthWrap {

	.roll {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		z-index: 98;
	}

	h1 {
		font-family: 'Irish Grover', cursive;
		color: #e16135;
		font-size: calc(3rem + 5vw);
		text-shadow: 0.35rem 0.35rem 0 #1C0621;
		animation: wank 5s linear infinite;
		perspective: 600px;
		transform-style: preserve-3d;
		transform-origin: bottom center;
	}

	h3 {
		font-family: 'Festive', cursive;
		color: #1C0621;
		font-size: 2rem;
		line-height: 5rem;
	}

	h2 {
		font-family: 'Montserrat', cursive;
		color: #fff;
		text-transform: uppercase;
		font-weight: bold;
		font-size: 2rem;
		margin-bottom: 2rem;
		line-height: 1.5rem;
		text-shadow: 0.25rem 0.25rem 0 #1C0621;
	}

	input[type="text"], input[type="password"], select, button {
		border: 2px solid #e16135;

		padding: 0.1em;
		border-radius: 50% 10% 10% / 50%;
		background: transparent;
		box-shadow: 0.25rem 0.25rem 0 #1C0621;
		width: 100%;
		backdrop-filter: blur(5px);
		text-align: center;
		font-family: 'Irish Grover', cursive;
		font-size: 1.5rem;
	}
	select {
		cursor: pointer;
	}
	input:focus, select:focus {
		outline: none;
	}

	label, legend, .label {
		font-family: "Montserrat", sans-serif;
		color: #1C0621;
	}

	fieldset {
		border: 2px solid #e16135;
		margin-top: 1em;
		margin-bottom: 1em;
		backdrop-filter: blur(10px);
		box-shadow: 0.25rem 0.25rem 0 #1C0621;
		padding: 0.5em;
		border-radius: 10% / 50% 10% 50%;
	}

	fieldset label, fieldset .label {
		color: #e16135;
		text-shadow: 0.1rem 0.1rem 0 #1C0621;
	}

	.signup__field {
		position: relative;
	}

	.select-field {
		margin-bottom: 1em;
	}

	input[type="radio"] {
		display: none;
	}
	input[type="radio"]+label {
		display: inline-block;
		border: 2px solid #e16135;
		border-radius: 20% / 20% 50% 10%;
		margin-top: 10em;
		margin: 0.5em;
		padding: 0.5em;
		box-shadow: 0.25rem 0.25rem 0 #1C0621;
		cursor: pointer;
	}
	input[type="radio"]+label:last-child {
		border-radius: 40% / 30% 20% 50%;
	}
	input[type="radio"]+label {
		border-radius: 40% / 30% 20% 50%;
	}
	input[type="radio"]:checked+label {
		color: #1C0621;
		background: #e16135;
		text-shadow: none;
	}
	input[type="checkbox"] {
		appearance: none;
		-webkit-appearance: none;
		cursor: pointer;
		position: relative;
		display: inline-block;
		margin: 0 0.5em 0 0;
		top: 0.2em;
		width: 1.5em;
		height: 1.5em;
		border: 2px solid #e16135;
		border-radius: 20% / 50% 50% 10%;
		box-shadow: 0.25rem 0.25rem 0 #1C0621;
	}
	input[type="checkbox"]+label {
		color: #e16135;
		line-height: 1em;
		cursor: pointer;
	}
	input[type="checkbox"]:checked:before {
		content: "";
		position: relative;
		top: -0.5em;
		left: 0.1em;
		display: block;
		width: 2em;
		height: 2em;
		background: #1C0621;
		transform-origin: bottom left;
		transform: scale(0.9);
		clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
	}
	input[type="checkbox"]:checked:after {
		content: "";
		position: relative;
		top: -2.8em;
		display: block;
		width: 2em;
		height: 2em;
		background: #e16135;
		transform-origin: bottom left;
		transform: scale(0.9);
		clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
	}

	button {
		color: #e16135;
		background: rgb(28,6,33,0.5);
		cursor: pointer;
	}

	button:active {
		background: rgb(28,6,33,0.8);
	}

	.moon {
		position: absolute;
		background: #ffda75;
		width: 16em;
		height: 16em;
		overflow: hidden;
		left: calc(50% - 8em);
		border-radius: 50%;
		box-shadow: 0 0 5em yellow;
	}
	.moon img {
		width: 100%;
		z-index: 98;
		filter: none;
		opacity: 0.2;
		filter: brightness(150%) drop-shadow(-0.2vw 0.2vw 0.1em #2D0B2F);
		-webkit-filter: brightness(150%) drop-shadow(-0.2vw 0.2vw 0.1em #2D0B2F);
	}

	.ground {
		position: fixed;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 100vh;
	}
	.ground .fog-1, .ground .fog-2 {
		position: fixed;
		width: 100vw;
		left: 50vw;
		bottom: -20vh;
		opacity: 0.2;
		z-index: -1;
	}
	.ground .fog-2 {
		width: 100vw;
		left: -25vw;
		top: 25vh;
	}
	.ground .ground-01 {
		position: fixed;
		width: 150vw;
		height: 150vw;
		left: -25vw;
		top: 35vh;
		background: rgb(0,0,0,0.2);
		border-radius: 50% 50% 0 0;
	}
	.ground .ground-02 {
		position: fixed;
		width: 120vw;
		height: 120vw;
		left: -50vw;
		bottom: -100vw;
		background: rgb(0,0,0,0.25);
		border-radius: 50% 50% 0 0;
	}
	.ground .ground-1 {
		position: fixed;
		width: 60vw;
		height: 60vw;
		left: -10vw;
		bottom: -55vw;
		background: black;
		border-radius: 50% 50% 0 0;
	}
	.ground .ground-2 {
		position: fixed;
		width: 100vw;
		height: 100vw;
		left: 10vw;
		bottom: -95vw;
		background: black;
		border-radius: 50% 50% 0 0;
	}
	.ground .ground-3 {
		position: fixed;
		width: 80vw;
		height: 80vw;
		right: -40vw;
		bottom: -65vw;
		background: black;
		border-radius: 50% 50% 0 0;
	}

	.lighting {
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100vh;
		background: #5f156f;
		background: #002f09;
		opacity: 0.3;
		z-index: 99;
		pointer-events: none;
	}

	img {
		opacity: 0.8;
		filter: grayscale(100%) brightness(200%) contrast(200%) drop-shadow(-0.2vw 0.2vw 0.1em #2D0B2F);
		-webkit-filter: grayscale(100%) brightness(200%) contrast(200%) drop-shadow(-0.2vw 0.2vw 0.1em #2D0B2F);
	}

	img.house {
		position: fixed;
		left: 15vw;
		bottom: 2.5vw;
		width: 15vw;
		animation: popup 2s linear forwards 1s,
		wank 5s linear infinite 3s,
		flicker 5s linear infinite;
		perspective: 600px;
		transform-style: preserve-3d;
		transform-origin: bottom center;
		transform: rotateY(-10deg) rotateX(-90deg);
	}

	img.cat {
		position: fixed;
		left: 10vw;
		bottom: 3.5vw;
		width: 5vw;
		animation: popup 2s linear forwards 2s,
		kitty 8s linear infinite 4s;
		perspective: 600px;
		transform-style: preserve-3d;
		transform-origin: bottom center;
		transform: rotateY(-10deg) rotateX(-90deg);
	}

	img.bat {
		position: fixed;
		left: -2.5vw;
		bottom: -1vw;
		width: 5vw;
	}
	.hanger {
		position: fixed;
		left: 12.5vw;
		top: -20vw;
		height: 25vw;
		border-left: 2px solid rgb(0,0,0,0.8);
		animation: popdown 1s linear forwards,
		swing 5s linear infinite 1s;
		perspective: 600px;
		transform-style: preserve-3d;
		transform-origin: top center;
		transform: translateY(-100%);
		box-shadow: -0.2vw 0.2vw 0.2em #2D0B2F;
	}

	img.witch {
		position: fixed;
		right: -6vw;
		bottom: -6vw;
		width: 10vw;
		transform: rotateY(180deg);
	}
	.hanger.witch-hanger {
		left: unset;
		right: 25vw;
		animation: popdown 1s linear forwards 1s,
		swing 5s linear infinite 2s;
	}

	.pumpkin {
		position: fixed;
		right: 0;
		top: 8vw;
		width: 10vw;
		height: 10vw;
		background: url(https://cdn.pixabay.com/photo/2021/09/20/04/19/pumpkins-6639634_960_720.png) no-repeat;
		filter: grayscale(100%) contrast(200%);
		-webkit-filter: grayscale(100%) contrast(200%);
		background-size: 80vw;
		background-position: 2vw 2vw;
		opacity: 0.8;
		animation: popdown 1s linear forwards 1.2s,
		swing 5s linear infinite 2.2s,
		flicker 5s linear infinite 0.7s;
		transform: translateY(-100vh);
		z-index: 80;
	}
	.pumpkin:before {
		content: "";
		display: block;
		width: 10vw;
		height: 50vw;
		position: fixed;
		left: 6vw;
		top: -45vw;
		border-left: 2px solid black;
	}
	.pumpkin.pumpkin-2 {
		background-position: 2vw -7.5vw;
		right: 8vw;
		top: 3vw;
		animation: popdown 1s linear forwards 1.4s,
		swing 5s linear infinite 2.4s,
		flicker 5s linear infinite 0.9s;
	}
	.pumpkin.pumpkin-3 {
		background-position: 2vw -16.5vw;
		left: 0;
		top: 15vw;
		animation: popdown 1s linear forwards 1.6s,
		swing 5s linear infinite 2.6s,
		flicker 5s linear infinite 1.1s;
	}
	.pumpkin.pumpkin-4 {
		background-position: -8vw -7.5vw;
		left: 10vw;
		top: 7vw;
		animation: popdown 1s linear forwards 1.8s,
		swing 5s linear infinite 2.8s,
		flicker 5s linear infinite 1.3s;
	}
	.pumpkin.pumpkin-5 {
		background-position: -8vw -34.5vw;
		right: 15vw;
		top: 15vw;
		animation: popdown 1s linear forwards 1.9s,
		swing 5s linear infinite 2.9s,
		flicker 5s linear infinite 1.4s;
	}
	.pumpkin.pumpkin-6 {
		background-position: -8vw -16.5vw;
		left: -1vw;
		top: 4vw;
		animation: popdown 1s linear forwards 2s,
		swing 5s linear infinite 3s,
		flicker 5s linear infinite 1.5s;
	}

	img.tree {
		position: fixed;
		right: 8vw;
		bottom: -6vw;
		width: 44vw;
		transform: rotateY(180deg);
		animation: popup2 2s linear forwards 0.5s,
		wank2 6s linear infinite 2.5s;
		perspective: 600px;
		transform-style: preserve-3d;
		transform-origin: bottom center;
		transform: rotateY(-190deg) rotateX(-90deg);
	}

	.form-login {
		.row {
			margin: 0 !important;
			&.btn-holder {
				margin-bottom: 1rem !important;
			}
		}
		button {
			text-align: center;
			font-size: 14px;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

}

@keyframes popup {
	0% {
		transform: rotateY(-10deg) rotateX(-90deg);
	}
	50% {
		transform: rotateY(-10deg) rotateX(10deg);
	}
	100% {
		transform: rotateY(-10deg) rotateX(-10deg);
	}
}
@keyframes popup2 {
	0% {
		transform: rotateY(-190deg) rotateX(-90deg);
	}
	70% {
		transform: rotateY(-190deg) rotateX(10deg);
	}
	100% {
		transform: rotateY(-190deg) rotateX(-10deg);
	}
}
@keyframes popdown {
	0% {
		transform: translateY(-100%);
	}
	70% {
		transform: translateY(10%);
	}
	80% {
		transform: translateY(-10%);
	}
	90% {
		transform: translateY(5%);
	}
	100% {
		transform: translateY(0);
	}
}
@keyframes wank {
	0%, 100% {
		transform: rotateY(-10deg) rotateX(-10deg);
	}
	50% {
		transform: rotateY(-10deg) rotateX(10deg);
	}
}
@keyframes wank2 {
	0%, 100% {
		transform: rotateY(-190deg) rotateX(-10deg);
	}
	50% {
		transform: rotateY(-190deg) rotateX(10deg);
	}
}
@keyframes flicker {
	0%, 1%, 3%, 5%, 100% {
		filter: grayscale(100%) brightness(100%) contrast(200%) drop-shadow(-0.2vw 0.2vw 0.1em #2D0B2F);
		-webkit-filter: grayscale(100%) brightness(100%) contrast(200%) drop-shadow(-0.2vw 0.2vw 0.1em #2D0B2F);
	}
	2%, 4% {
		filter: grayscale(100%) brightness(0%) contrast(200%) drop-shadow(-0.2vw 0.2vw 0.1em #2D0B2F);
		-webkit-filter: grayscale(100%) brightness(0%) contrast(200%) drop-shadow(-0.2vw 0.2vw 0.1em #2D0B2F);
	}
}
@keyframes kitty {
	0%, 100% {
		transform: rotateY(-10deg) rotateX(-10deg);
	}
	10% {
		transform: rotateY(-10deg) rotateX(10deg) scaleY(1.2) scaleX(0.8);
	}
}
@keyframes swing {
	0%, 50%, 100% {
		transform: rotateY(0) translateY(0);
	}
	25% {
		transform: rotateY(-30deg) translateY(2%);
	}
	75% {
		transform: rotateY(30deg) translateY(-2%);
	}
}
</style>

